import { render, staticRenderFns } from "./EmbedSlideConfig.vue?vue&type=template&id=be071ede&scoped=true"
import script from "./EmbedSlideConfig.vue?vue&type=script&lang=js"
export * from "./EmbedSlideConfig.vue?vue&type=script&lang=js"
import style0 from "./EmbedSlideConfig.vue?vue&type=style&index=0&id=be071ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be071ede",
  null
  
)

export default component.exports